export default "__VITE_ASSET__BSJL6DY1__"